import React, { useState, useEffect, useContext } from 'react';



import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function RebuildStock(props) {

  let { type, isDebit } = props;

  const { api, userData, warehouseData, selectedCompany, refData, selectedYear } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [warehouse, setWarehouse] = useState([]);
  const createdBy = parseInt(userData.id);
  const companyId = selectedCompany.id;
  const yearId = selectedYear.id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['warehouse']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  // WareHouse Options
  const warehouseOptions = warehouseData?.map(item => ({
    value: item.id,
    label: item.name,
  }))

  const handleSubmit = async () => {

    if (!warehouse.value) {
      toast.error('Please Select Warehouse')
      return;
    }


    setLoadingEffect(true);
    const data = {
      companyId: companyId,
      yearId: yearId,
      warehouseId: warehouse.value,
    }


    try {
      let res = await api.post(`tools/reStockAll`, data);

      if (res.data.status) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setLoadingEffect(false);
    }
  }



  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

      <Spin spinning={loadingEffect}  fullscreen />

      <Card style={{ textAlign: 'center', width: '600px' }}>
        <p>
          This method will recalculate the quantity of each product across warehouse.<br />
          Please note that this process may take some time to complete.
        </p>
        <Row className="mb-4">
          <Col md={3}>
          </Col>
          <Col md={6}>
            <Select
              options={warehouseOptions}
              isSearchable={true}
              placeholder="Select Warehouse"
              onChange={setWarehouse}
              value={warehouse}
              required
            />
          </Col>

        </Row>

        <Row>
          <Col md={4}>
          </Col>
          <Col md={4}>
            <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={handleSubmit}>Rebuild Stock</Button>
          </Col>
        </Row>
      </Card >

    </div >


  )
}

export default RebuildStock;
